import { render } from "./ChatWindow.vue?vue&type=template&id=0e4f4b5b&scoped=true"
import script from "./ChatWindow.vue?vue&type=script&lang=js"
export * from "./ChatWindow.vue?vue&type=script&lang=js"

import "./ChatWindow.vue?vue&type=style&index=0&id=0e4f4b5b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e4f4b5b"

export default script